export default {
  title: 'Registros SMS',

  // Form related
  form: {
    timeRange: 'Rango de Tiempo',
    sendTime: 'Tiempo de Envío',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    task: 'Tarea',
    taskName: 'Nombre de Tarea',
    taskPlaceholder: 'Por favor, selecciona tarea',
    taskNamePlaceholder: 'Por favor, selecciona nombre de tarea',
    taskType: 'Tipo de Tarea',
    taskTypePlaceholder: 'Por favor, selecciona tipo de tarea',
    username: 'Nombre de Usuario',
    userName: 'Nombre de Usuario',
    user: 'Usuario',
    usernamePlaceholder: 'Por favor, ingresa nombre de usuario',
    userNamePlaceholder: 'Por favor, ingresa nombre de usuario',
    userPlaceholder: 'Por favor, ingresa nombre de usuario',
    phone: 'Número de Teléfono',
    phonePlaceholder: 'Por favor, ingresa número de teléfono',
    channel: 'Canal',
    channelPlaceholder: 'Por favor, selecciona canal',
    status: 'Estado',
    statusPlaceholder: 'Por favor, selecciona estado',
    receipt: 'Código de Recepción',
    receiptPlaceholder: 'Por favor, ingresa código de recepción',
    updateTime: 'Tiempo de Actualización',
    updateTimePlaceholder: 'Por favor, selecciona tiempo de actualización'
  },

  // Table related
  table: {
    time: 'Tiempo',
    task: 'Tarea',
    user: 'Usuario',
    phone: 'Teléfono',
    channel: 'Canal',
    status: 'Estado',
    receipt: 'Recepción'
  },

  // Status related
  status: {
    pending: 'Pendiente',
    success: 'Exitoso',
    failed: 'Fallido',
    unknown: 'Desconocido'
  },

  // Export related
  export: {
    button: 'Exportar',
    loading: 'Tarea de exportación creada. Verifica el progreso en la lista de descargas.',
    statusNotFailed: 'Solo se pueden exportar registros fallidos. Por favor, establece el filtro de estado a "Fallido" antes de exportar.',
    noData: 'No hay datos para exportar',
    tooMany: 'Máximo 100,000 registros por exportación. Por favor, ajusta tus filtros.'
  },

  // Message related
  message: {
    queryFailed: 'Consulta fallida',
    exportSuccess: 'Exportación exitosa',
    exportFailed: 'Fallo en la exportación'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} registros'
  }
};
